// @ts-nocheck
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { useAmp } from 'next/amp';
import Axios from 'axios';
import Container from '../../atoms/Container/Container';
import Styles from './SearchBar24.css';
import debounce from 'lodash/debounce';

// function includeOriParameter(url) {
//   const uri = url || '';

//   const splitted = uri.split('?');

//   if (splitted.length > 1) {
//     return `${url}&ori=SF&int_source=menusca`;
//   } else {
//     return `${url}?ori=SF&int_source=menusca`;
//   }
// }

function SearchBar24({ mobile, formId, importPrefix, open, onClose, ...props }) {
  const endpoint = process.env.NEXT_PUBLIC_SEARCH_ENDPOINT;
  const params = process.env.NEXT_PUBLIC_SEARCH_PARAMS;

  const isAmp = useAmp();
  const [list, setList] = React.useState([]);
  const [text, setText] = React.useState('');
  const inputRef = React.useRef(null);

  const handleChange = React.useCallback(
    async (ev) => {
      try {
        const value = ev.target.value || '';
        setText(value);

        if (!value.trim()) {
          setList([]);
          return;
        }

        const uri = `${endpoint}${value.trim()}${params}`;
        const { data } = await Axios.get(uri);
        const result = data?.searchMenu?.results?.links || [];
        setList(Array.isArray(result) ? result : [result]);
      } catch (error) {
        setList([]);
      }
    },
    [endpoint, params],
  );

  const delayedHandle = React.useMemo(() => {
    return debounce(handleChange, 300);
  }, [handleChange]);

  // if (!isAmp && mobile && !open) {
  //   return <></>;
  // }

  return (
    <>
      <div
        className={[
          'search-input-container',
          !isAmp && mobile && !open ? 'disable-input-container' : '',
        ].join(' ')}
        {...props}
      >
        <input
          ref={inputRef}
          id={formId}
          maxLength="100"
          name="name"
          required
          placeholder="O que você procura?"
          on={`input-debounced:AMP.setState({ showSearchResults:true, textSearch: event.value, searchUrl: '${endpoint}' + event.value + '${params}' })`}
          onChange={delayedHandle}
          autoComplete="off"
          aria-autocomplete="none"
        />

        <div className="search-mobile-icons">
          {(isAmp || (!text && !isAmp)) && (
            <span>
              {isAmp && (
                <amp-img
                  src={`${importPrefix}static/amp/shared/assets/ic_search_gray.svg`}
                  alt="ícone de lupa"
                  width="16"
                  height="16"
                />
              )}

              {!isAmp && !mobile && (
                <img
                  src={`${importPrefix}static/amp/shared/assets/ic_search_gray.svg`}
                  alt="ícone de lupa"
                  width="16"
                  height="16"
                />
              )}
            </span>
          )}

          {(isAmp || (text && !isAmp) || (mobile && !isAmp)) && (
            <span
              on={`tap:AMP.setState({showMobileSearch: false, showSearchResults: false, textSearch: ''}), ${formId}.clear`}
              role="button"
              tabIndex="0"
              onClick={() => {
                if (onClose) {
                  onClose();
                }

                setText('');
                setList([]);

                try {
                  if (inputRef.current) {
                    inputRef.current.value = '';
                  }
                } catch (er) {
                  //
                }
              }}
            >
              {isAmp && (
                <amp-img
                  src={`${importPrefix}static/amp/shared/assets/s_close.svg`}
                  alt="fechar menu"
                  width="16"
                  height="16"
                />
              )}

              {!isAmp && (
                <img
                  src={`${importPrefix}static/amp/shared/assets/s_close.svg`}
                  alt="fechar menu"
                  width="16"
                  height="16"
                />
              )}
            </span>
          )}

          {/* <span
            on="tap:AMP.setState({showSearchResults: true})"
            role="button"
            tabIndex="0"
            hidden
            data-amp-bind-hidden={mobile ? 'false' : 'textSearch.length <= 0'}
          >
            {isAmp && (
              <amp-img
                src={`${importPrefix}static/amp/shared/assets/s_arrow.svg`}
                width="22"
                height="16"
              />
            )}

            {!isAmp && (
              <img
                src={`${importPrefix}static/amp/shared/assets/s_arrow.svg`}
                alt=""
                width="22"
                height="16"
              />
            )}
          </span> */}
        </div>

        <span className="search-line" />
      </div>

      <div
        className="search-position"
        id={mobile ? 'search-results-position-mobile' : 'search-results-position'}
        hidden={isAmp}
        data-amp-bind-hidden="(showSearchResults == false || textSearch.length <= 0)"
      >
        {isAmp && (
          <article className="search-results">
            <amp-list
              width="auto"
              height="500px"
              layout="fixed-height"
              data-amp-bind-src="searchUrl"
              items="searchMenu.results.links"
            >
              <div fallback="" />
              <template type="amp-mustache">
                <a className="url-entry" href="{{link}}">
                  <Container className="url-content">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: `{{ title }}`,
                      }}
                    />

                    <span className="search-link-url" role="button" tabIndex="0">
                      <amp-img
                        src={`${importPrefix}static/amp/shared/assets/s_arrow_b.svg`}
                        width="22"
                        height="16"
                      />
                    </span>
                  </Container>
                </a>
              </template>
            </amp-list>
          </article>
        )}
        {!isAmp && list && list.length > 0 && (
          <article className="search-results">
            <div className="ampless-list-results">
              {list.map((l) => {
                return (
                  <a className="url-entry" href={l.link} key={`search-result-${l.id}`}>
                    <Container className="url-content">
                      <p>{l.title}</p>

                      <span className="search-link-url" role="button" tabIndex="0">
                        <img
                          src={`${importPrefix}static/amp/shared/assets/s_arrow_b.svg`}
                          alt=""
                          width="22"
                          height="16"
                        />
                      </span>
                    </Container>
                  </a>
                );
              })}
            </div>
          </article>
        )}
      </div>

      <style jsx>{Styles}</style>
    </>
  );
}

SearchBar24.defaultProps = {
  importPrefix: '',
};

export default SearchBar24;
